import nabil from "../assets/images/Trainer/nabil-img.png";
import alex from "../assets/images/Trainer/alex-img.png";
import jpg from "../assets/images/Trainer/jpg-img.png";
import ryan from "../assets/images/Trainer/ryan-img.png";
import russel from "../assets/images/Trainer/russel-img.png";
// DEFINE HEALER IMAGES
import phillip from "../assets/images/healers/phillip-valentine-img.png";
import drsebi from "../assets/images/healers/dr-Sebi-img.png";
import robert from "../assets/images/healers/robert-morse-img.png";
import bowman from "../assets/images/healers/victor-bowman.png";
import yahki from "../assets/images/healers/yahki-img.png";
import wim_hof from "../assets/images/healers/wim-hof-img.png";
import aboutImg from "../assets/images/Trainer/about-img1.png";
import aboutImg2 from "../assets/images/Trainer/about-img2.png";
import aboutImg3 from "../assets/images/Trainer/about-img3.png";
// HEALER SMALL SCREEN IMAGES
import drsebi_sm from "../assets/images/healers/dr-sabi-sm.png";
import yahki_sm from "../assets/images/healers/yahki-sm.png";
import wim_sm from "../assets/images/healers/wim_sm.png";
import dr_robert_sm from "../assets/images/healers/dr_robert_sm.png";
import dr_phillip_sm from "../assets/images/healers/dr-phillip-sm.png";
import victor_bowman_sm from "../assets/images/healers/victor-bowman-sm.png";

import moduleslider1 from "../assets/images/module_slider/module1.jpg";
import moduleslider2 from "../assets/images/module_slider/module2.jpg";
import moduleslider3 from "../assets/images/module_slider/module3.jpg";
import moduleslider4 from "../assets/images/module_slider/module4.jpg";
import moduleslider5 from "../assets/images/module_slider/module5.jpg";
import moduleslider6 from "../assets/images/module_slider/module6.jpg";
import moduleslider7 from "../assets/images/module_slider/module7.jpg";
import moduleslider8 from "../assets/images/module_slider/module8.jpg";
import moduleslider9 from "../assets/images/module_slider/module9.jpg";
import moduleslider10 from "../assets/images/module_slider/module10.jpg";
import moduleslider11 from "../assets/images/module_slider/module11.jpg";
import moduleslider12 from "../assets/images/module_slider/module12.jpg";
import moduleslider13 from "../assets/images/module_slider/module13.jpg";
import moduleslider14 from "../assets/images/module_slider/module_group.png";
import refresh_icon from "../assets/images/module_slider/svg/refresh-icon.svg";

import testimonys1 from "../assets/images/testimonyals/img1.png";
import testimonys1hover1 from "../assets/images/testimonyals/img1_hover_1.png";
import testimonys1hover2 from "../assets/images/testimonyals/img1_hover_2.png";
import testimonys2 from "../assets/images/testimonyals/img2.png";
import testimonys2hover1 from "../assets/images/testimonyals/img2_hover_1.png";
import testimonys2hover2 from "../assets/images/testimonyals/img2_hover_2.png";
import testimonys3 from "../assets/images/testimonyals/img3.png";
import testimonys3hover1 from "../assets/images/testimonyals/img3_hover_1.png";
import testimonys4 from "../assets/images/testimonyals/img4.png";
import testimonys4hover1 from "../assets/images/testimonyals/img4_hover_1.png";
import testimonys4hover2 from "../assets/images/testimonyals/img4_hover_2.png";
import testimonys5 from "../assets/images/testimonyals/img5.png";
import testimonys5hover1 from "../assets/images/testimonyals/img5_hover_1.png";
import testimonys5hover2 from "../assets/images/testimonyals/img5_hover_2.png";
import testimonys6 from "../assets/images/testimonyals/img6.png";
import testimonys6hover1 from "../assets/images/testimonyals/img6_hover_1.png";
import testimonys7 from "../assets/images/testimonyals/img7.png";
import testimonys7hover1 from "../assets/images/testimonyals/img7_hover_1.png";
import testimonys8 from "../assets/images/testimonyals/img8.png";
import testimonys8hover1 from "../assets/images/testimonyals/img8_hover_1.png";
import testimonys8hover2 from "../assets/images/testimonyals/img8_hover_2.png";
import testimonys9 from "../assets/images/testimonyals/img9.png";
import testimonys9hover1 from "../assets/images/testimonyals/img9_hover_1.png";
import testimonys9hover2 from "../assets/images/testimonyals/img9_hover_2.png";
import testimonys10 from "../assets/images/testimonyals/img10.png";
import testimonys10hover1 from "../assets/images/testimonyals/img10_hover_1.png";
import testimonys10hover2 from "../assets/images/testimonyals/img10_hover_2.png";
import testimonys11 from "../assets/images/testimonyals/img11.png";
import testimonys11hover1 from "../assets/images/testimonyals/img11_hover_1.png";
import testimonys11hover2 from "../assets/images/testimonyals/img11_hover_2.png";
import testimonys12 from "../assets/images/testimonyals/img12.png";
import testimonys12hover1 from "../assets/images/testimonyals/img12_hover_1.png";
import testimonys12hover2 from "../assets/images/testimonyals/img12_hover_2.png";
import testimonys13 from "../assets/images/testimonyals/img13.png";
import testimonys13hover1 from "../assets/images/testimonyals/img13_hover_1.png";
import testimonys14 from "../assets/images/testimonyals/img14.png";
import testimonys14hover1 from "../assets/images/testimonyals/img14_hover_1.png";
import testimonys14hover2 from "../assets/images/testimonyals/img14_hover_2.png";
import testimonys15 from "../assets/images/testimonyals/img15.png";
import testimonys15hover1 from "../assets/images/testimonyals/img15_hover_1.png";
import testimonys15hover2 from "../assets/images/testimonyals/img15_hover_2.png";
import testimonys16 from "../assets/images/testimonyals/img16.png";
import testimonys16hover1 from "../assets/images/testimonyals/img16_hover_1.png";
import testimonys17 from "../assets/images/testimonyals/img17.png";
import testimonys17hover1 from "../assets/images/testimonyals/img17_hover_1.png";
import testimonys17hover2 from "../assets/images/testimonyals/img17_hover_2.png";
import testimonys18 from "../assets/images/testimonyals/img18.png";
import testimonys18hover1 from "../assets/images/testimonyals/img18_hover_1.png";
import testimonys19 from "../assets/images/testimonyals/img19.png";
import testimonys19hover1 from "../assets/images/testimonyals/img19_hover_1.png";
import testimonys20 from "../assets/images/testimonyals/img20.png";
import testimonys20hover1 from "../assets/images/testimonyals/img20_hover_1.png";
import testimonys20hover2 from "../assets/images/testimonyals/img20_hover_2.png";
import testimonys21 from "../assets/images/testimonyals/img21.png";
import testimonys21hover1 from "../assets/images/testimonyals/img21_hover_1.png";

import laptop from "../assets/images/bonuses/png/laptop.png";
import bonuses2 from "../assets/images/bonuses/png/bonuses2.png";
import bonuses3 from "../assets/images/bonuses/png/bonuses3.png";
import bonuses4 from "../assets/images/bonuses/png/bonuses4.png";
import bonuses5 from "../assets/images/bonuses/png/bonuses5.png";
import bonuses6 from "../assets/images/bonuses/png/bonuses6.png";
import bonuses7 from "../assets/images/bonuses/png/bonuses7.png";
import bonuses8 from "../assets/images/bonuses/png/bonuses8.png";

import programs1 from "../assets/images/programs/png/program-img1.png";
import programs2 from "../assets/images/programs/png/program-img2.png";
import programs3 from "../assets/images/programs/png/program-img3.png";
import programs4 from "../assets/images/programs/png/program-img4.png";
import programs5 from "../assets/images/programs/png/program-img5.png";
import programs6 from "../assets/images/programs/png/program-img6.png";
import programs7 from "../assets/images/programs/png/program-img7.png";

export const trainerData = [
  {
    imgUrl: nabil,
    heading: `Nabil "French Phenom"`,
    para: [
      {
        text: "Pro Powerlifter ",
      },
      {
        text: "Master Deadlift  Specialist ",
      },
      {
        text: "World Record Holder ",
      },
      {
        text: "powerlifters",
      },
      {
        text: "Powerlifting Specialist",
      },
      {
        text: "5x Bodyweight Deadlift",
      },
      {
        text: "10X Bodyweight totalL",
      },
    ],
  },
  {
    imgUrl: alex,
    heading: "Alex Sowell (deadlift) Tree)",
    para: " MASTER DEADLIFT SPECIALIST",
    para: [
      {
        text: "650+ Deadlift",
      },
      {
        text: "Coached 100s of elitle level powerlifters",
      },
      // {
      //   text: "level powerlifters",
      // },
      {
        text: "Nasa Enginnerr ",
      },
    ],
  },
  {
    imgUrl: ryan,
    heading: "Ryan Jewers",
    para: [
      {
        text: "Master of science BAsed ",
      },
      {
        text: "Hypertrophy training",
      },
    ],
  },
  {
    imgUrl: jpg,
    heading: "JPG Coaching",
    para: [
      {
        text: "Master of science BAsed ",
      },
      {
        text: "Hypertrophy training",
      },
    ],
  },
  {
    imgUrl: russel,
    heading: "Russel Orhii (Russwole)",
    para: [
      {
        text: "The Best Powerlifter In The World ",
      },
      {
        text: "83 KG USAPL & IPF Raining Champion",
      },
      {
        text: "Bodybuilder",
      },
      {
        text: " World Record Holder In Squat, Deadlift,",
      },
      {
        text: "& Total",
      },
    ],
  },
];
export const healerData = [
  {
    imgUrl: drsebi,
    imgUrl2: drsebi_sm,
    heading: "Dr Sebi ",
    para: [
      {
        text: "Master Healer ",
      },
      {
        text: "Creator of alkaline diet",
      },
      {
        text: "Healer of 1,000s",
      },
      {
        text: "Detox Specialist",
      },
      {
        text: "Herbalist",
      },
    ],
  },
  {
    imgUrl: wim_hof,
    imgUrl2: wim_sm,
    heading: "Wim Hof",
    para: [
      {
        text: "MAster of cold Therapy and breathing",
      },
      {
        text: "techniques",
      },
    ],
  },
  {
    imgUrl: yahki,
    imgUrl2: yahki_sm,
    heading: "Yahki Awakened",
    para: [
      {
        text: "Master Healer ",
      },
      {
        text: "herbalist ",
      },
      {
        text: "Bio chemist,",
      },
      {
        text: "Fruitrian Diet Specialist ",
      },
      {
        text: "Spiritual Teacher  ",
      },
      {
        text: "Detox Specialist",
      },
      {
        text: "Alchemist ",
      },
      {
        text: "psychologist  ",
      },
      {
        text: "1,000s of testominys reversing disease ",
      },
    ],
  },
  {
    imgUrl: robert,
    imgUrl2: dr_robert_sm,
    heading: "Dr Robert Morse",
    para: [
      {
        text: "Master Healer ",
      },
      {
        text: "herbalist ",
      },
      {
        text: "Bio chemist,",
      },
      {
        text: "Naturopathic physician,",
      },
      {
        text: "iridologist,",
      },
      {
        text: "Fruitrian Diet Specialist,",
      },
    ],
  },
  {
    imgUrl: phillip,
    imgUrl2: dr_phillip_sm,
    heading: "Dr Phillip Valentine ",
    para: [
      {
        text: "Master teacher of utilizing the ",
      },
      {
        text: "elements to heal your mind body and ",
      },
      {
        text: "soul",
      },
    ],
  },
  {
    imgUrl: bowman,
    imgUrl2: victor_bowman_sm,
    heading: "Dr Sebi's Son (Victor Bowman)",
    para: [
      {
        text: "Master Herbalist",
      },
      {
        text: " Grew up & Learned From Dr Sebi (his father)",
      },
      {
        text: "Travels The World & Studies In The Field",
      },
      {
        text: "Alkaline Master",
      },
      {
        text: "True Healer of 1,000s Around The World",
      },
    ],
  },
];

export const aboutText = [
  {
    imgUrl: aboutImg,
    para1: "About The Course Instructor (Noah Fleming)",
    para2:
      "If there's one thing that'll strike you about Noah, it's that he's able to go incredibly in-depth to give his students more than just the basics with his knowledge on not just fitness, but holistic healing and connecting the two together.",
  },
  {
    imgUrl: aboutImg2,
    para1:
      "He doesn't just teach you about calories or working out, he teaches you about minerals, herbs, the biological structure of the body, alkaline foods, the cause of disease, and so much more.",
    para2:
      "He helps you overcome your weak points from lack of available education. There is nothing more important than that.",
  },
  {
    imgUrl: aboutImg3,
    para1:
      "Noah's fitness journey began in 2019 and he's remained consistent even through the worst periods of his life, something we should all strive for.",
    para2:
      "A master of discipline and a veteran of self improvement/ healing, Noah has achieved the 'lifeless to brightness' transformation that all young men aspire for.",
  },
];

export const moduleData = [
  {
    moduleImg: moduleslider1,
    moduleIcon: refresh_icon,
    title: "Moudle 1",
    heading: "COURSE INTRO",
    modulePara1: "1) WELCOME",
    modulePara2: "2) DE-PROGRAMMING YOUR SUB-CONSCIOUS MIND",
    modulePara3: "3) ASSESSING YOUR PROBLEMS",
    modulePara4: "4) STARTING FRESH (MINDSET CHANGE)",
    modulePara5: "5) ESCAPING THE MATRIX",
  },
  {
    moduleImg: moduleslider2,
    moduleIcon: refresh_icon,
    title: "Moudle 2",
    heading: "healing",
    modulePara1: "1) What Is Healing?",
    modulePara2: "2) You Have Been Lied To",
    modulePara3: "3) The Cosmic arrangement",
    modulePara4: "4) The connection of healing & Exersice/gym",
    modulePara5: "5) The connection of healing & business/success",
    modulePara6: "6) The Importance of Healing Your Body",
  },
  {
    moduleImg: moduleslider3,
    moduleIcon: refresh_icon,
    title: "Moudle 3",
    heading: "Diet Knowledge",
    modulePara1: "1) What Was The Human Body Designed To Eat?",
    modulePara2:
      "2) Do You Need Meat, Dairy, or Supplements To Build Muscle/Strength?",
    modulePara3: "3) The Plant Based Lifestyle (transition diet) Learn more",
    modulePara4:
      "4) The Alkaline Plant Lifestyle (Learn How To Get High Complete Protein From Plants)",
    modulePara5: "5) Fruitrian (heal all dis-ease)",
    modulePara6: "6) H302",
    modulePara7: "7) Lose Weight, Gain Weight, Maingain Weight",
    modulePara8: "8) Fasting",
    modulePara9:
      "9) How To Maximize Muscle Growth/Strength With Plants (Eating Routine)",
    modulePara10: "10) Creating Your Diet Plan",
  },
  {
    moduleImg: moduleslider4,
    moduleIcon: refresh_icon,
    title: "Moudle 4",
    heading: "Shopping For High Protein Alkaline Plant Foods",
    modulePara1:
      "1) How To Shop When In The Grocery Store For High Protein Alkaline Foods",
    modulePara2: "2) Breaking Down Why I Buy What I Buy!",
    modulePara3: "3) Fruitrian (heal all dis-ease)",
    modulePara4:
      "4) The Alkaline Plant Lifestyle (Learn How To Get High Complete Protein From Plants) ",
    modulePara5: "5) H302",
    modulePara6: "6) Lose Weight, Gain Weight, Maingain Weight",
    modulePara7: "7) Fasting",
    modulePara8:
      "8) How To Maximize Muscle Growth/Strength With Plants (Eating Routine)",
    modulePara9: "9) Creating Your Diet Plan",
  },
  {
    moduleImg: moduleslider5,
    moduleIcon: refresh_icon,
    title: "Moudle 5",
    heading: "Diet Meals (Cooking With Me)",
    modulePara1:
      "1) 'Morning Oats' High Protein Alkaline Replacement (pre workout meal)",
    modulePara2: "2) High Protein Alkaline Waffle (pre workout meal)",
    modulePara3:
      "3) Chickpea Eggs with Butternut Squash Hasbrowns (pre workout meal)",
    modulePara4: "4)  Protein Alkaline Pancakes (pre workout meal)",
    modulePara5:
      "5) Baked Chickpeas Pasta Humus w/ Cucumbers (pre workout meal)",
    modulePara6: "6) High Protein Alkaline Fruit Smoothie (post workout meal)",
    modulePara7: "7) Green Alkaline Health Shake (post workout meal)",
    modulePara8: "8) Green Alkaline Health Shake (post workout meal) V2",
    modulePara9: "9) High Protein Cookie smoothie bowl",
    modulePara10: "10) High Protein VEGAN Smoothie Bowl (post workout)",
    modulePara11: "11) High Protein Chickpea Vegtable Stir Fry Bowl (dinner) ",
    modulePara12: "12) Alkaline Sushi Rolls (dinner)",
    modulePara13: "13) Alkaline Lasagna (dinner)",
    modulePara14: "14) Chickpea Lettuce Burrito Wraps (dinner)",
    modulePara15: "15) Alkaline Chips & Guacamole (snack)",
    modulePara16: "16) Vegan Protein Balls (snack)",
    modulePara17: "17) Alkaline 'Honey Nut Cheerios' (snack)",
    modulePara18: "18) Alkaline 'Penut Butter' Cookies (snack)",
    modulePara19: "19) Alkaline Browines (snack)",
    modulePara20: "20) Milk Replacement (Walnut Milk)",
    modulePara21: "21) Cheese Replacement (Brazil Nut Cheese)",
  },
  {
    moduleImg: moduleslider6,
    moduleIcon: refresh_icon,
    title: "Moudle 6",
    heading: "Healing/Hydrating Juices + TEas (how to make)",
    modulePara1: "1) Cucumber + Apple Juice",
    modulePara2: "2) Watermelon Juice ",
    modulePara3: "3) Coconut Water",
    modulePara4: "4) Tamarind Juice",
    modulePara5: "5) Skin Detox Tea",
    modulePara6: "6) Hair Growth & Health Tea",
  },
  {
    moduleImg: moduleslider7,
    moduleIcon: refresh_icon,
    title: "Moudle 7",
    heading: "Herbs",
    modulePara1: "1) Herbs 101",
    modulePara2: "2) The Different Ways To Take Herbs",
    modulePara3:
      "3) Top 5 Herbs for Better Muscle Growth/Recovery & Mental Health!",
    modulePara4: "4) When To Use Herbs To Detox",
    modulePara5: "5) Is Marijuina a Healthy Herb to Consume?",
    modulePara6: "6) Different Type Of Herbal Cleanses To Heal Any Dis-ease",
    modulePara7: "7) Setting up Your Herb Cleanse! (body detox",
    modulePara8: "8) Daily Driver Herbs (after your detox)",
  },
  {
    moduleImg: moduleslider8,
    moduleIcon: refresh_icon,
    title: "Moudle 8",
    heading: "Workout Knowledge",
    modulePara1: "1) Unfinished Art Piece",
    modulePara2: "2) What Are Your Goals?",
    modulePara3: "3) Different Styles of Working Out",
    modulePara4: "4) Science Based Training (maximize your gains)",
    modulePara5:
      "5) How To Pack On Muscle FAST! (bodybuilding) (Best Workout for each muscle group of the body)",
    modulePara6: "6) How To Get Seriously Strong (powerlifting) ",
    modulePara7:
      "7) The Best Way to Train (gain strength&size at the same time)",
    modulePara8: "8) Picking Your Workout Program",
    modulePara9: "9) How To Warm-Up Properly Before Ever Workout",
  },
  {
    moduleImg: moduleslider9,
    moduleIcon: refresh_icon,
    title: "Moudle 9",
    heading: "Workout Form Vids",
    modulePara1: "1) Squat",
    modulePara2: "2) Bench",
    modulePara3: "3) Deadlift",
    modulePara4: "4) Overhead Shoulder Press",
    modulePara5: "5) Biceps",
    modulePara6: "6) Triceps",
    modulePara7: "7) Back + Traps",
    modulePara8: "8) Shoulders",
    modulePara9: "9) Push Day",
    modulePara10: "10) Pull Day",
    modulePara11: "11) Leg Day",
    modulePara12:
      "12) Powerlifting Only Workout (showing you how i train the compound lifts in action)",
  },
  {
    moduleImg: moduleslider10,
    moduleIcon: refresh_icon,
    title: "Moudle 10",
    heading: "Recovery",
    modulePara1: "1) Why Is recovery the most important for muscle growth?",
    modulePara2: "2) Pre & Post Workout Recovery (increase gains)",
    modulePara3:
      "3) How To Never Get Injured (stretching) (consistency is key)",
    modulePara4: "4) Diet",
    modulePara5: "5) Ice Baths",
    modulePara6: "6) Yoga",
    modulePara7: "7) Sleep & meditation ",
    modulePara8: "8) The benefits you will gain",
  },
  {
    moduleImg: moduleslider11,
    moduleIcon: refresh_icon,
    title: "Moudle 11",
    heading: "Meditation",
    modulePara1: "1) Chakras",
    modulePara2: "2) The Different Types Of Meditation",
    modulePara3: "3) Fleming Fruit Tree Breathing Method",
    modulePara4: "4) Meditation Tips/Tricks (increase meditation experiences)",
    modulePara5: "5) What Type Of Meditation Is Best For You",
  },
  {
    moduleImg: moduleslider12,
    moduleIcon: refresh_icon,
    title: "Moudle 12",
    heading: "Setting Up Your Future",
    modulePara1: "1) Laws Of The Universe + Karmic debt",
    modulePara2: "2) Treat Life Like A Video Game",
    modulePara3: "3) How To Build A Business Doing What You Love",
    modulePara4: "4) Escaping The System + Gain Power",
  },
  {
    moduleImg: moduleslider13,
    moduleIcon: refresh_icon,
    title: "Moudle 13",
    heading: "FAQ",
    modulePara1: "1) Laws Of The Universe + Karmic debt",
    modulePara2: "2) Treat Life Like A Video Game",
    modulePara3: "3) How To Build A Business Doing What You Love",
    modulePara4: "4) Escaping The System + Gain Power",
  },
  {
    moduleImg: moduleslider14,
  },
];

export const testimonysData = [
  {
    videoLink: "https://youtube.com/shorts/lRrIY3QXV3M?feature=share",
    testimonysImg: [testimonys1, testimonys1hover1, testimonys1hover2],
    title: "Noah Fleming",
    desc: "I have been learning from the best healers of our generation, and the best bodybuilders/powerlifters, to come up with the best holistic method to clean the body while also packing on muscle. This took 4-5 years of trial and ERROR on my own body, while ALOS studying BIO CHEMISTRY, EXERSICE SCIENCE, AND HErbology and putting it all together to create the transformation you see today on my own body, and all of my amazing brothers who used this information to their advantage :)",
  },
  {
    videoLink: "https://youtu.be/FlSXYf9PpMA",
    testimonysImg: [testimonys2, testimonys2hover1, testimonys2hover2],
    title: "Jim Brazil ",
    desc: "At a very young age i have always wanted to be in top level shape, and this is what lead me to develope an eating disorder in my early teenage years. But once i did more research about fitness and health, Noah's page poped up and i emmitly felt a connect and followed him. After this i saw he had a put together all of his knowledge in one place, or sale, that was the turing point in my life. This course taught me 99% of what i know today about trainning, a healing diet, recovery, holistic healing methods, herbs, and so much more. I cannot reccommend this program enough to anyone whois still in stage one of wanting to change but doesnt know where to start. In just 2 years i have built this pysique using the course and i know you can too. Just stick to the plan and you will see the results start to come in rappidly",
  },
  {
    videoLink: "https://youtu.be/Yfm8MbCYcCY",
    testimonysImg: [testimonys3, testimonys3hover1, testimonys3],
    title: "Forest Fortier",
    desc: "I first started my journey in end of 2019, and this is also right around when i started follow Noah on social media. I went from an average kid who felt lost, always looking for that something in my life to give me purpose and a sense of self love, to completely changing my life around by working first on my physical body, then my mind, and then my spirit. Through Noah, i have learned the ins and outs of meditation, cold therapy, proper science based trainning routines, diet, and so much more. for anyone who was in the spot i was in a few years ago, i cannot recommend this course enough for you. It will allow you to reduce the stress and work load of trying to find all the correct information, by having it in one place, and not having to worry if the information is inaccrate because it really does bring in the best results ",
  },
  {
    videoLink: "https://youtu.be/zE4OBb9F_bs",
    testimonysImg: [testimonys4, testimonys4hover1, testimonys4hover2],
    title: "Urvil Shah",
    desc: "I don't know where to start. I am so greatful the world aligned me with noah because if it wasn't for the inforamtion i have gained from him, i will still be at my darkest point in life. Noah has turned my life around by changing my diet, starting to workout, meditate., ground in nature, do cold therapy, and so much more! All of this lead to such fast changes in my body, i couldnt beilibve how my body was changing on the day to day basis. Now i eat an almost fully raw plant based diet, meditate mulitiple times a day, and go hard in the gym 6 days a week.. This is going to be the best investment of your life because you will gain something that is priceleess which is self love and disapline to reaching your goals!",
  },
  {
    videoLink: "https://youtu.be/SfIgx12-6uc",
    testimonysImg: [testimonys5, testimonys5hover1, testimonys5hover2],
    title: "Dalton Short ",
    desc: "'I am a d1 football at Monmouth Hawks Football. Ever since working in person and through online with noah my performance on and off the field has completely changed for the better. I use to feel mental fog, physical fatigue, and felt stuck at the muscle mass/weight i was at. After just two months working with him as you can see from the pictures, not only has my physique completely changed, but my mental state has never been better. I went up 15 pounds in 2 months and gained minimal fat. Implementing noah's holistic practices is what really made this change happen. The meditations, ice baths, plant based foods, herbs post workouts like seamoss and burdock, all of these things make me feel like i have infinite amounts of energy. I cannot recommend noah's course enough because it does a phenomenal job of mixing mental, physically, and spiritually health, to combine and provide you with the best possible performance in whatever you do!' - DSHORT",
  },
  {
    videoLink: "https://youtu.be/-SL0uHQB77M",
    testimonysImg: [testimonys6, testimonys6hover1, testimonys6],
    title: "El Scoot",
    desc: "'At  14 years of age i started my fitness and health journey. I have now been on the journey for a full 7 months and have seen insane progress. the reason why i started this journey is because i had major depression and insequritys about myself, until i came across one of noah's video on my explore page, and he opned up my mind to a whole new lifestyle. I started to listen and follow his advice with meditation, grounding, connecting back to nature, working out, eating better, and foucsing more time and energy towards the things that will set up my future to be successful. This course geniunly has everything you need to transform your mind & body to that next level i know a lot of people want in their life. I want to give a special thanks to noah and all of the work he is doing to help elavte the people in a better direction' - EL",
  },
  {
    videoLink: "https://youtu.be/AP8ty6eESpw",
    testimonysImg: [testimonys7, testimonys7hover1, testimonys7],
    title: "Christian Lebron",
    desc: "'Noah Was the one who inspired me to do more than just lifting. I got inspired by him to start taking ice baths, mediate, eat healthier, and this all lead to me achiving my goals faster. The best pand most helpful part for me was that, noah brought these holistic healing ideas to my reality, and then i saw he had this course, so i hopped on the oppurtunity right away. I cannot tell you how much it is worth investing your time and money, for a pricless outcome of self loe and development ' - Christian Lebron",
  },
  {
    videoLink: "https://youtu.be/lR-0X_kqSxU",
    testimonysImg: [testimonys8, testimonys8hover1, testimonys8hover2],
    title: "Mayson Morse",
    desc: "'There is nothing more empowering as a women to get your mind body and soul in control to feel good about yourself. Through Noah's Content, it has opened me up to alot of healing alternatives to help me fasten my progress in and out of the gym terrmendously.Working out, eating healthy, drinking lots of water, listening to positive podcast, detoxing in the sauna, meditation, cold showers, getting sufficient sleep, grounding, sunlight and reading inspiration books have all helped me become so much more excited for life in general. I feel like my energy levels are through the roof and I feel strong and healthy to just take on anything life throws at me. Making these small changes in your life can lead to huge overall results in all aspects of your life.' - MAyson",
  },
  {
    videoLink: "https://youtu.be/F0nQReWqFiY",
    testimonysImg: [testimonys9, testimonys9hover1, testimonys9hover2],
    title: "Xander Shultz",
    desc: "'It was an amazing experience! It relieved a ton of my stress and connected me to the real world. I Become plant based and Implemented holistic healing methods like meditation, stretching, yoga, breathing, and this mixed with a plant badSed diEt and the gym, i truley feel unstoppable! I'd definitely recommend it!' - Xander",
  },
  {
    videoLink: "https://youtu.be/_diST9T9eno",
    testimonysImg: [testimonys10, testimonys10hover1, testimonys10hover2],
    title: "Jack Bolognone",
    desc: "This Course Noah Made is what cured my addiction to video games. I went from playing video games 6 hours a day, to meditating 2-3 times a day and never missing a meal or workout. I want people to geniunely know that if you follow the steps noah teaches, you will transform your body with no question",
  },
  {
    videoLink: "https://youtu.be/cfmSBZVCGmI",
    testimonysImg: [testimonys11, testimonys11hover1, testimonys11hover2],
    title: "Oliver Paul",
    desc: "'What got me to start my journey in the first place was due to how bad my skin disease called egsma was. This limited me to be able to sleep comfortable at night and really do anything without feeling so itchy and irratated. But once i went through this enitre course and learned all this knowledge, i am going to past this same motivation onto other ecause of how powerfully it impacted and changed my life around for the better.  Yoga, meditation, Cold plung, all Raw plant based diet, and so much more, have all lead me to curing my skin disease and my negative mental health. I am now super present in the moment and have 100% self love for myself:)' - Oliver",
  },
  {
    videoLink: "https://youtu.be/SkvQWr4-oRY",
    testimonysImg: [testimonys12, testimonys12hover1, testimonys12hover2],
    title: "Hayden Neubert",
    desc: "'It is so easy to get caught up in all the entertainm,ent, party's and actions that will not create longevity. I use to be exactly that, someone who would put those type of meaningless things before myself. But ever since i came across noah and his course, i can honestly say my life has been taking a full 360 turn. I am only 3 months deep into my self improvement journey, so i am so excited to see what the future holds as i contuine to pick up on need knowledge everyday from noah. If you are a beginner and just started to workout, i still highly suggest this course for you because it will teach you literally everything' - Hayden",
  },
  {
    videoLink: "https://youtu.be/SkvQWr4-oRY",
    testimonysImg: [testimonys13, testimonys13hover1, testimonys13],
    title: "Arsb Gupta",
    desc: "Not only did noah change my lifePhyscially, but menrally and spiritally i have became so much more connected and intune with myself. i went from having 0 self love, to loving my mind body ans spirit uncoNdionally, just by using the hOlistic methods noah teaches.  ",
  },
  {
    videoLink: "https://youtu.be/8Vuxa7lXkaI",
    testimonysImg: [testimonys14, testimonys14hover1, testimonys14hover2],
    title: "Adam Peterson",
    desc: "'I saw Noah on my fyp 1 year ago and I’ll never forget that right then and there i decided to change my life around. Now that it has been a full year and half later, I can truly say I have matured so much and put instant gratification behind me, resulting in me building myself up mentally physically and financially. By using Noah’s knowledge and holistic muscle building methods, I have become a lot more comfortable and grounded with my own thoughts and emotions towards my own self. Noah has the tools you need to transform your life mentally, physically, and spiritually, but you have to remember that it will still take hard work and some serious consistency! If I can change, anyone can change with this knowledge Noah provides in his course' - Adam",
  },
  {
    videoLink: "https://youtu.be/N2y7W2VKBw4",
    testimonysImg: [testimonys15, testimonys15hover1, testimonys15hover2],
    title: "jake delega ",
    desc: "'Since when I first met Noah he has always been informative and uplifting. We became close friends fast and at the time when we met I was still dipping my feet into strength training and things similar to that. Overtime Noah has taught me many things such as the importance of mental clarity, manifestation, mobility, diet, and many more. His work ethic shows and being in contact with him transfers over and helps build your dedication. You’re not only gaining a program to build a physique, but a guidance in uplifting your lifestyle.' - Jake D",
  },
  {
    videoLink: "https://youtu.be/bw8hxejGTIM",
    testimonysImg: [testimonys16, testimonys16hover1, testimonys16],
    title: "Grady  White",
    desc: "'When i first started out in my journey i came across noah on a tik tok livestream and for whatever reason something was telling me to not keep scrolling and watch what he was talking about. The message he ws preaching was super real and inspiring and this is what really kickstarted my journey. Fast forward 1.5 years later after putting to use the methods i learned from noah, and it is safe to say they 100% don't just work, but they can build you dream mind body and soul in under a years length of time. With dedication + Proper trainnig, diet, recover, and the holistic practices noah teaches, your progress will literally 10x!' - Gary White",
  },
  {
    videoLink: "https://youtu.be/4yb5G0g59Xc",
    testimonysImg: [testimonys17, testimonys17hover1, testimonys17hover2],
    title: "Jamie Lucas",
    desc: "'Where to start, since being in contact with Noah I’ve made nothing but progress, I was skeptical about the type of lifestyle with questions like what sources of protein, fats etc were present in this regime but he answered everything and put every single question to bed in a very developed and intricate manner. Very details but not too long allowing it to be affective, his abundance knowledge in not only muscle building but the whole lifestyle just elevated me truly. As you can see by the progress pictures it really speaks for itself this was over a 7 month period!' - Jamie",
  },
  {
    videoLink: "https://youtu.be/IYkBvKFktjI",
    testimonysImg: [testimonys18, testimonys18hover1, testimonys18],
    title: "UnAi Fit",
    desc: "'Before seeing Noah and his methods, i was already going to thegym for quite sometime, but i still felt something missing. One day i came across noah on my explore page and relaized i needed tO take back contol of my mental health. mastering mediation was something i always wanted to learn but diDnt know whree to start. with noahs help, i can honestly say i have mastered Mediation, and Have neevr felt so mentalLy clear in my life! ' - Unai '",
  },
  {
    videoLink: "https://youtu.be/FO1He8G5fQQ",
    testimonysImg: [testimonys19, testimonys19hover1, testimonys19],
    title: "Caden madamba",
    desc: "'I use to eat lots of dairy, meat, and processed junk food. I HAVE ALWAYS HAD A FAST MATABOLISM SO IT NEVER EFFECTED MY BODYFAT, BUT MY INTERAL HEALTH WAS SUFFERING. EVER SINCE I IMPLEMENTED THE HOLISTIC METHODS NOAH PROVIDED , MY HAIR, SKIN, NAILS, ENERGY LEVELS, AND LASTLY GAINS IN THE GYM ALL RAIPLY INCREASED AND GOT BETTER. I NEVER WAS A BEILIVER IN THE ALL PLANT BASED DIET NOAH WOULD TALK ABOUT, BUT AFTER THESE RESULTS, I SEE WHY HE SPEAKS SO PASSONITLY ABOUT HIS METHODS IN HEALING THE BODY AND BUILDING MUSCLE' - Caden",
  },
  {
    videoLink: "https://youtube.com/shorts/1qIP6COKkYI?feature=share",
    testimonysImg: [testimonys20, testimonys20hover1, testimonys20hover2],
    title: "Zachariah",
    desc: "'My coaching experience propelled my progress immensely. Being able to constantly interact with Noah and get feed back on form and other critiques I was able to properly set myself up for success and make the most of our my fitness journey. I was not only able to improve myself physically through lifting weights but also was taught that through nutrition and meditation one can elevate to a whole new higher level of self which only made the experience that much more rewarding. I got in line with my true self again and because of that took large leaps of improvement in my power lifting journey.' - Zachariah",
  },
  {
    videoLink: "https://youtube.com/shorts/1qIP6COKkYI?feature=share",
    testimonysImg: [testimonys21, testimonys21hover1, testimonys21],
    title: "Cooper Lang",
    desc: "'First off, I just want to thank Noah for what he has done not just for me, but for countless others. He was and is always very encouraging and determined to help as many people as he can. He is a truly a blessing and I cannot be more thankful. Thanks Brotha! One love!'' - Cooper",
  },
];

export const bonusesData = [
  {
    bonusImg: laptop,
    bonusHeading: "BONUS 1",
    bounsPara:
      "Learn how to cook with me in the most efficient, No bullsh*t way, to build muscle fast off high protein plant meals! Recipe Videos!",
    bonusPrice: "(Worth: $149)",
    colorr: " linear-gradient(180deg, #ffffff 0.01%, #da7600 100%)",
  },
  {
    bonusImg: bonuses2,
    bonusHeading: "BONUS 2",
    bounsPara:
      "Private Group Chat - 24/7 access to Noah and anyone else who bought the course",
    bonusPrice: "(Worth: $200)",
    colorr:
      "linear-gradient(180deg, rgba(170, 212, 255, 0.02) 0.01%, #AAD4FF 100%)",
  },
  {
    bonusImg: bonuses3,
    bonusHeading: "BONUS 3",
    bounsPara:
      "Alkaline Plant Approved Food List - Alkaline Plant approved food list to cleanse your body and build muscle at the same time!",
    bonusPrice: "(Worth: $20)",
    colorr:
      "linear-gradient(180deg, rgba(170, 212, 255, 0.02) 0.01%, #FF0909 100%)",
  },
  {
    bonusImg: bonuses4,
    bonusHeading: "BONUS 4",
    bounsPara:
      "Recorded All The Essential Workouts And Compounds You Need To Learn How To Perfect Your form For Safe And Faster Gains in The Gym!",
    bonusPrice: "(WORTH: $149)",
    colorr:
      "linear-gradient(180deg, rgba(151, 71, 255, 0.02) 0.01%, #9747FF 100%)",
  },
  {
    bonusImg: bonuses5,
    bonusHeading: "BONUS 5",
    bounsPara:
      "Plant Based Groceries List - Never have to make a grocer list again. All the plant foods you need to build lots of muscle all in one place",
    bonusPrice: "(Worth: $20)",
    colorr: "linear-gradient(180deg, #FFFFFF 0.01%, #D0CA16 100%)",
  },
  {
    bonusImg: bonuses6,
    bonusHeading: "BONUS 6",
    bounsPara:
      "Affiliate Link You'll get an affiliate link to help your friends to buy this course - Make 50% of the sale when someone buys the course after the full release  ",
    bonusPrice: "(Worth: $198 PER SALE)",
    colorr: "linear-gradient(180deg, rgba(0, 153, 89, 0) 0.01%, #00B234 100%)",
  },
  {
    bonusImg: bonuses7,
    bonusHeading: "BONUS 7",
    bounsPara:
      "Get My Personal Plant Based Diet Plan That Made My Body & Mind Transformation Possible",
    bonusPrice: "(Worth: $99)",
    colorr: "linear-gradient(180deg, #FFFFFF 0.01%, #002C3C 100%)",
  },
  {
    bonusImg: bonuses8,
    bonusHeading: "BONUS 8",
    bounsPara:
      "Get my Personal Meditation & Mental Health Methods That Changed My Life 360",
    bonusPrice: "(Worth: $99)",
    colorr: "linear-gradient(180deg, #FFFFFF 0.01%, #212121 100%)",
  },
];
export const programsData = [
  {
    bonusImg: programs1,
    programHeading: "1) 12 Week Aesthetic/Strength Program",
    para: [
      {
        text: "-35 Page E-Book",
      },
      {
        text: "- 72 Workouts",
      },
      {
        text: "- 6 Days a week workout routine",
      },
      {
        text: "- Power-lifting & Bodybuilding",
      },
      {
        text: "- Build Strength & Aesthetics",
      },
    ],
    programPrice: "(Worth: $99)",
    programscolor: "linear-gradient(205.84deg, #E42B29 3.74%, #DA7600 98.88%)",
  },
  {
    bonusImg: programs2,
    programHeading: "2) 12 Week Meditation/Mental Health Program",
    para: [
      {
        text: "- 155+ Pages!!",
      },
      {
        text: "- 84 Days Of Clearing Your Mind",
      },
      {
        text: "- Get Rid Of Poor Mental Healthv",
      },
      {
        text: "- Get Rid Of Poor Mental Healthv",
      },
      {
        text: "- Find Your Life Purpose",
      },
      {
        text: "- Unlock Your Full Brain To Achieve Your Biggest Goals",
      },
    ],
    programPrice: "(Worth: $99)",
    programscolor: "linear-gradient(205.84deg, #868204 3.74%, #D0CA16 98.88%)",
  },
  {
    bonusImg: programs3,
    programHeading: "3) Plant Based Diet Program ",
    para: [
      {
        text: "- 35+ Pages (more being added every week!)",
      },
      {
        text: "- 15 Full Meal Recipes",
      },
      {
        text: "- 5 High Protein Full day of Eating's",
      },
      {
        text: "- Master The Balance of Eating Plants to Build TONS Of Muscle",
      },
    ],
    programPrice: "(WORTH: $89)",
    programscolor: "linear-gradient(205.84deg, #002708 3.74%, #009F2C 98.88%)",
  },
  {
    bonusImg: programs4,
    programHeading: "4) Noah's Arm Program",
    para: [
      {
        text: "- 30 Page E-Book",
      },
      {
        text: "- 10 Workouts Total",
      },
      {
        text: "- 6 Full Arm Workouts",
      },
      {
        text: "- 3 Bicep Only Workouts",
      },
      {
        text: "- 1 Tricep Only Workout",
      },
    ],
    programPrice: "(WORTH: $39)",
    programscolor: "linear-gradient(205.84deg, #2F0F4C 3.74%, #A176D6 98.88%)",
  },
  {
    bonusImg: programs5,
    programHeading: "5) Alkaline Vegan Cookbook",
    para: [
      {
        text: "- 80 pages (more being added every month) ",
      },
      {
        text: "- 45+ Recipes",
      },
      {
        text: "- 15+ High Protein Plant Based Meals",
      },
    ],
    programPrice: "(Worth: $39)",
    programscolor: "linear-gradient(205.84deg, #000101 3.74%, #04365F 98.88%)",
  },
  {
    bonusImg: programs6,
    programHeading: "6) Noah's science based lifting program",
    para: [
      {
        text: "- 84 days of science based workouts",
      },
      {
        text: "- 45+ E-book pages",
      },
      {
        text: "- All of Noah's gem exercises.",
      },
      {
        text: "- The perfect program to start after the ''12 week power building program'' that comes with the course",
      },
    ],
    programPrice: "(Worth: $99)",
    programscolor: "linear-gradient(205.84deg, #6D0000 3.74%, #A01717 98.88%)",
  },
  {
    bonusImg: programs7,
    programHeading: "7) Natural Remedy E-Book/Program",
    para: [
      {
        text: "- 38+ pages",
      },
      {
        text: "Creator of alkaline diet",
      },
      {
        text: "- 50+ Natural Remedy's",
      },
      {
        text: "- Replace Fake Supplements With Real Natural Remedies & herbs",
      },
      {
        text: "-Protect Your Health Against The Chemicals We Have Been Programmed To Use in our toothpaste, shampoos, soaps, and even cleaning supply's",
      },
    ],
    programPrice: "(Worth: $99)",
    programscolor: "linear-gradient(205.84deg, #308200 3.74%, #70FF19 98.88%)",
  },
];
